module.exports = __webpack_public_path__ + "img/img4.449df13d.svg";